import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const welcomeBody = `You have received this notification from Desert Sage Seminars because you are a registered user. You have successfully registered with Desert Sage Seminars. PLEASE SAVE THIS EMAIL FOR YOUR RECORDS.
Your Username and Password will enable you to enroll in our courses at any time.
Your Username is as follows:

Username: username

Please remember that the Password you created is case sensitive.

You affirmed the following to be true:
  • I will be the person taking these classes, and
  • I realize that it is a felony to impersonate a real estate licensee
  • I will not complete more than 9 renewal hours within the same calendar day

At any time while taking a course, you will be able to contact Tech Support* should you encounter a problem with our website, or Course Support* should you encounter any issues with the course, the text, quizzes or anything course related.
* Support will be available 7 days a week from 7:30 AM to 9:00 PM Arizona time.
Thank you for registering with Desert Sage Seminars. We are sure you will find our courses to be an efficient and valuable use of your time.

Cordially

Jon Kichen, Instructor
Owner/Administrator
Desert Sage Seminars
Phone: 602-377-6207
URL: www.DesertSageSeminars.com`;
export function EditEmailDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-738">
      <div className="flex items-center justify-between" data-id="element-739">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-740">Edit Email Detail</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/email-details')} data-id="element-741">
          ← Back to Email Details
        </Button>
      </div>

      <Card data-id="element-742">
        <CardContent className="pt-6" data-id="element-743">
          <form className="space-y-5 max-w-2xl" data-id="element-744">
            <Input label="Subject" defaultValue="Welcome to Desert Sage Seminars" data-id="element-745" />

            <div data-id="element-746">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-747">
                Body
              </label>
              <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-748">
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-749">
                  <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-750">
                    Source
                  </button>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-751" />
                  {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-752">
                      {ic}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-753" />
                  {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-754">
                      {ic}
                    </button>)}
                </div>
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-755">
                  {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-756">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-757" />
                  {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-758">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-759" />
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-760">
                    <option data-id="element-761">Styles</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-762">
                    <option data-id="element-763">Format</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-764">
                    <option data-id="element-765">Font</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-766">
                    <option data-id="element-767">Size</option>
                  </select>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-768" />
                  {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-769">
                      {t}
                    </button>)}
                </div>
                <textarea className="w-full p-3 text-sm focus:outline-none resize-y min-h-[200px] bg-white" defaultValue={welcomeBody} data-id="element-770" />
              </div>
            </div>

            <div className="pt-2 flex items-center gap-4" data-id="element-771">
              <Button type="submit" data-id="element-772">Submit</Button>
            </div>
          </form>

          <div className="mt-6 pt-4 border-t border-slate-200 space-y-1" data-id="element-773">
            <p className="text-sm font-medium text-slate-700" data-id="element-774">Actions</p>
            <div className="flex flex-col gap-1 text-sm text-blue-600" data-id="element-775">
              <button className="text-left hover:underline text-red-500 w-fit" data-id="element-776">
                Delete
              </button>
              <button className="text-left hover:underline w-fit" onClick={() => navigate('/email-details')} data-id="element-777">
                List Email Details
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}